// // Function to retrieve a cookie by name
// function getCookie(cname) {
//   var name = cname + "=";
//   var ca = document.cookie.split(';');
//   for (var i = 0; i < ca.length; i++) {
//     var c = ca[i];
//     while (c.charAt(0) == ' ') c = c.substring(1);
//     if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
//   }
//   return false;
// }
//
// // Function to apply the urchin variables to links
// function updateApplyink(urchinVals) {
//   const parsedUrchinVals = JSON.parse(urchinVals);
//   const applyLinks = document.querySelectorAll('a[href*="/external-apply-form"]');
//   let qs = '';
//
//   // Build the query string from the parsed values
//   for (const key in parsedUrchinVals) {
//     if (parsedUrchinVals.hasOwnProperty(key) && parsedUrchinVals[key]) { // Ensure property exists and is not empty
//       qs += '&' + key + '=' + encodeURIComponent(parsedUrchinVals[key]); // Use encodeURIComponent for safety
//     }
//   }
//   qs = qs.replace('&', '?'); // Replace the first '&' with '?'
//
//   applyLinks.forEach(link => {
//     // Only append if the link doesn't already have a query string
//     if (link.href.indexOf('?') === -1) {
//       link.href += qs;
//     } else {
//       // If link already has query string, append additional parameters
//       link.href += qs.replace('?', '&'); // Append with '&' if there's already a '?'
//     }
//   });
// }
//
// /**
//  * Main function to determine UTM parameters and apply them.
//  * This function is async to correctly handle the fetch API call.
//  */
// async function determineAndApplyUtms() {
//   let utmMedium;
//   let utmSource;
//   let utmCampaign;
//   const urlParams = new URLSearchParams(window.location.search);
//
//   // 1. Check URL querystring for UTMs
//   utmMedium = urlParams.get('utm_medium');
//   utmSource = urlParams.get('utm_source');
//   utmCampaign = urlParams.get('utm_campaign');
//
//   // Assign default values if not supplied in the URL
//   if (!utmMedium) {
//     utmMedium = 'organic'; // Default medium if not found in URL
//   }
//   if (!utmCampaign) {
//     utmCampaign = 'direct'; // Default campaign if not found in URL
//   }
//
//   // Handle utmSource fallbacks only if it wasn't found in the URL
//   if (!utmSource) {
//     // Priority 1: Check 'initial_referrer' cookie
//     let referrerFromServerCookie = getCookie("initial_referrer");
//     if (referrerFromServerCookie && referrerFromServerCookie !== 'null') {
//       //console.log('Using utmSource from initial_referrer cookie:', referrerFromServerCookie);
//       utmSource = referrerFromServerCookie;
//     } else {
//       // Priority 2: Make the API call
//       //console.log('No initial_referrer cookie, trying API call /utm/initial-referrer...');
//       let apiReferrer = null;
//       try {
//         const response = await fetch('/utm/initial-referrer', { // AWAIT the fetch call
//           method: 'GET',
//           headers: {
//             'Accept': 'application/json'
//           }
//         });
//
//         if (!response.ok) {
//           throw new Error(`HTTP error! status: ${response.status}`);
//         }
//         const result = await response.json(); // AWAIT the JSON parsing
//
//         if (result && result.initial_referrer && typeof result.initial_referrer === 'string' && result.initial_referrer !== 'null') {
//           apiReferrer = result.initial_referrer;
//           //console.log('Using utmSource from API response:', apiReferrer);
//         } else {
//           //console.log('API response was empty or invalid for initial_referrer.');
//         }
//
//       } catch (error) {
//         //console.error('Fetch error for /utm/initial-referrer:', error);
//         // If API fails, apiReferrer will remain null
//       }
//
//       if (apiReferrer) {
//         utmSource = apiReferrer;
//       } else if (document.referrer) {
//         // Priority 3: client-side document.referrer
//         //console.log('API did not provide utmSource, using document.referrer:', document.referrer);
//         utmSource = document.referrer;
//       } else {
//         // Priority 4: final fallback to current hostname
//         //console.log('API and document.referrer did not provide utmSource, using window.location.hostname:', window.location.hostname);
//         utmSource = window.location.hostname;
//       }
//     }
//   }
//
//   // Set the cookie and update the apply link with the determined values
//   const urchinValsToStore = JSON.stringify({
//     utm_medium: utmMedium,
//     utm_source: utmSource,
//     utm_campaign: utmCampaign
//   });
//
//   document.cookie = "urchinVals=" + urchinValsToStore + "; max-age=" + (60 * 60 * 24 * 365) + "; path=/"; // Set cookie for 365 days
//
//   updateApplyink(urchinValsToStore);
//   console.log('Final UTMs applied:', { utm_medium: utmMedium, utm_source: utmSource, utm_campaign: utmCampaign });
// }
//
//
// // --- Execution Flow ---
// let urchinValsFromCookie = getCookie("urchinVals");
//
// if (urchinValsFromCookie !== false) {
//   // Cookie set, update the apply link directly
//   updateApplyink(urchinValsFromCookie);
//   //console.log('Using UTMs from cookie:', JSON.parse(urchinValsFromCookie));
// } else {
//   // No 'urchinVals' cookie, start the asynchronous process of determining UTMs
//   determineAndApplyUtms();
// }
//
//
//

/**
 * @fileoverview This script intercepts fetch requests for Dynamics 365 Marketing form submissions.
 * It checks for a 'utm_variables' cookie and, if present, finds and updates existing form fields
 * with the UTM data before the form is sent.
 * Includes a test mode that enables verbose logging and blocks the actual submission.
 */

/**
 * Retrieves the value of a specific cookie by its name.
 * @param {string} name - The name of the cookie to find.
 * @returns {string | null} The cookie's value, or null if not found.
 */
function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

/**
 * Main function to initialize the form interception logic.
 */
function initializeInterceptor() {
  // --- A. SET TO LIVE/TEST MODE ---
  // true: Enables detailed console logs and blocks the form from sending.
  // false: Disables logs and allows the form to send normally.
  const isTestMode = false;

  // --- 1. Define the mapping from UTM parameters to Dynamics field IDs ---
  const dynamicsFieldMap = {
    'utm_source': 'ceg_campaignsource',
    'utm_campaign': 'ceg_marketingcampaign',
    'utm_medium': 'c9_utmmedium'
  };

  if (isTestMode) {
    console.log('Interceptor: v0.3');
    console.log("Interceptor is in TEST MODE. Submissions will be blocked and logged.");
    console.log("DEBUG: All cookies visible to script:", document.cookie);
  }

  // Store the original, unmodified fetch method.
  const originalFetch = window.fetch;

  // --- 2. Override the global window.fetch method ---
  window.fetch = (input, init) => {

    // Define the conditions for identifying the specific Dynamics form submission request.
    const isSubmissionUrl = (new RegExp(/landingpageforms\/forms\/[a-f0-9-]+$/)).test(input.toString());
    const isDynamicsFormSubmission = !!(
      init?.method === 'POST' &&
      isSubmissionUrl &&
      typeof init?.body === 'string'
    );

    if (isTestMode) {
      console.log(`FETCH INTERCEPTED: URL: ${input.toString()}, Method: ${init?.method || 'GET'}, Is Dynamics Submission? -> ${isDynamicsFormSubmission}`);
    }

    if (isDynamicsFormSubmission) {
      if (isTestMode) console.log("Dynamics form submission detected. Processing...");

      const currentUtmCookieValue = getCookie('utm_variables');

      if (currentUtmCookieValue) {
        try {
          const bodyObj = JSON.parse(init.body);

          if (!bodyObj.fields) {
            bodyObj.fields = [];
          }

          const decodedCookie = decodeURIComponent(currentUtmCookieValue);
          const utmData = JSON.parse(decodedCookie);

          // --- UPDATED LOGIC: Find and update existing fields, or append if not found ---
          for (const [utmKey, dynamicsId] of Object.entries(dynamicsFieldMap)) {
            if (utmData[utmKey]) {
              const value = utmData[utmKey];

              // Find the index of the field if it already exists in the payload.
              const existingFieldIndex = bodyObj.fields.findIndex(field => field.key === dynamicsId);

              if (existingFieldIndex > -1) {
                // Field exists, so update its value.
                bodyObj.fields[existingFieldIndex].value = value;
                if (isTestMode) console.log(`Updating existing field -> ${dynamicsId}: "${value}"`);
              } else {
                // Field does not exist, so push a new entry (this is a fallback).
                bodyObj.fields.push({ key: dynamicsId, value: value });
                if (isTestMode) console.log(`Injecting new field -> ${dynamicsId}: "${value}"`);
              }
            }
          }

          init.body = JSON.stringify(bodyObj);

        } catch (error) {
          // This error log is important for both test and live modes.
          console.error("Error processing form submission payload.", error);
        }
      } else {
        if (isTestMode) console.warn("Could not find 'utm_variables' cookie at time of form submission.");
      }

      // The test mode block to log the final payload and prevent submission.
      if (isTestMode) {
        console.group("--- FORM SUBMISSION BLOCKED (TEST MODE) ---");
        console.log("The following data would have been submitted (as a JSON object):");
        console.log(JSON.parse(init.body));
        console.groupEnd();

        return Promise.resolve(new Response(JSON.stringify({
          message: "Submission intercepted in test mode."
        }), { status: 200, headers: {'Content-Type': 'application/json'} }));
      }
    }

    // Call the original fetch to allow the request to proceed.
    return originalFetch(input, init);
  };
}

// --- Run the interceptor function after the page has fully loaded ---
window.addEventListener('load', initializeInterceptor);
